export enum SECTIONS {
	MAIN = 'main',
	REQUISITES = 'Requisites',
	DOCUMENTS = 'documents',
	REQUESTS = 'requests',
	USERS = 'users',
}

export const TranslateSection = {
	[SECTIONS.MAIN]: 'Вернуться в главную',
	[SECTIONS.REQUISITES]: 'Реквизиты',
	[SECTIONS.DOCUMENTS]: 'Документы',
	[SECTIONS.REQUESTS]: 'Запросы',
	[SECTIONS.USERS]: 'Пользователи',
}
